import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export const submitVolunteer = (payload) => api.post("/volunteer", payload).then((r) => r.data);
export const submitContact = (payload) => api.post("/contact", payload).then((r) => r.data);

export const fetchVolunteers = (token) =>
  api.get("/volunteers", { headers: { "X-Admin-Token": token } }).then((r) => r.data);
export const fetchContacts = (token) =>
  api.get("/contacts", { headers: { "X-Admin-Token": token } }).then((r) => r.data);
